module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('tplheader'), _vm._v(" "), _c('tplLeftPanel'), _vm._v(" "), _c('form', [_c('div', {
    staticClass: "fixed-top-menu-outer",
    attrs: {
      "id": "fixed-top-menu-outer"
    }
  }, [_c('div', {
    staticClass: "fixed-top-menu"
  }, [_c('div', {
    staticClass: "pull-right"
  }, [_c('ajaxLoaderButton', {
    attrs: {
      "onClick": _vm.save,
      "iconclass": "fa fa-save",
      "label": "Ment"
    },
    model: {
      value: (_vm.is_save),
      callback: function($$v) {
        _vm.is_save = $$v
      },
      expression: "is_save"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "main-panel",
    attrs: {
      "id": "main-panel"
    }
  }, [_c('div', {
    staticClass: "content-panel"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "content-panel-top-btn-group"
  }, [_c('ajaxLoaderButton', {
    attrs: {
      "onClick": _vm.save,
      "iconclass": "fa fa-save",
      "label": "Ment"
    },
    model: {
      value: (_vm.is_save),
      callback: function($$v) {
        _vm.is_save = $$v
      },
      expression: "is_save"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_vm._m(2), _vm._v(" "), _c('form', [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_vm._m(3), _vm._v(" "), _c('select2ajax', {
    attrs: {
      "url": "shibuser/search",
      "change": _vm.shibUserChange,
      "id": "dn",
      "label": "Címtár felhasználó",
      "errors": _vm.errors,
      "name": "dn"
    },
    model: {
      value: (_vm.form.shib_users),
      callback: function($$v) {
        _vm.$set(_vm.form, "shib_users", $$v)
      },
      expression: "form.shib_users"
    }
  }), _vm._v(" "), _c('inputbox', {
    attrs: {
      "id": "username",
      "label": "Felhasználónév",
      "errors": _vm.errors,
      "name": "username"
    },
    model: {
      value: (_vm.form.user.username),
      callback: function($$v) {
        _vm.$set(_vm.form.user, "username", $$v)
      },
      expression: "form.user.username"
    }
  }), _vm._v(" "), _c('inputbox', {
    attrs: {
      "id": "email",
      "label": "Email",
      "errors": _vm.errors,
      "name": "email"
    },
    model: {
      value: (_vm.form.user.email),
      callback: function($$v) {
        _vm.$set(_vm.form.user, "email", $$v)
      },
      expression: "form.user.email"
    }
  }), _vm._v(" "), _c('inputbox', {
    attrs: {
      "inputCheck": "name",
      "id": "fullname",
      "label": "Név",
      "errors": _vm.errors,
      "name": "fullname"
    },
    model: {
      value: (_vm.form.user.fullname),
      callback: function($$v) {
        _vm.$set(_vm.form.user, "fullname", $$v)
      },
      expression: "form.user.fullname"
    }
  }), _vm._v(" "), _c('inputbox', {
    attrs: {
      "id": "password",
      "label": "Jelszó",
      "errors": _vm.errors,
      "name": "password"
    },
    model: {
      value: (_vm.form.user.password),
      callback: function($$v) {
        _vm.$set(_vm.form.user, "password", $$v)
      },
      expression: "form.user.password"
    }
  }), _vm._v(" "), _c('inputbox', {
    attrs: {
      "id": "password_",
      "label": "Jelszó újra",
      "errors": _vm.errors,
      "name": "password_"
    },
    model: {
      value: (_vm.form.user.password_),
      callback: function($$v) {
        _vm.$set(_vm.form.user, "password_", $$v)
      },
      expression: "form.user.password_"
    }
  }), _vm._v(" "), _c('combobox', {
    attrs: {
      "change": _vm.groupChange,
      "id": "group_id",
      "label": "Csoport",
      "errors": _vm.errors,
      "name": "group_id"
    },
    model: {
      value: (_vm.form.user_groups),
      callback: function($$v) {
        _vm.$set(_vm.form, "user_groups", $$v)
      },
      expression: "form.user_groups"
    }
  }), _vm._v(" "), _c('select2', {
    attrs: {
      "multi": "true",
      "id": "card_types",
      "label": "Kezelhető kártyatípusok",
      "errors": _vm.errors,
      "name": "card_types"
    },
    model: {
      value: (_vm.form.card_types),
      callback: function($$v) {
        _vm.$set(_vm.form, "card_types", $$v)
      },
      expression: "form.card_types"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_vm._m(4), _vm._v(" "), _c('ulRule', {
    attrs: {
      "rootClass": "tree",
      "rules": _vm.form.rules
    }
  })], 1)])])])])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "breadcrumb"
  }, [_c('li', [_vm._v("Kezdőőoldal")]), _vm._v(" "), _c('li', [_vm._v("Felhasználók")]), _vm._v(" "), _c('li', [_vm._v("Felhasználó")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-title"
  }, [_c('h1', [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("chevron_right")]), _vm._v("Felhasználó")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', [_vm._v("Felhasználó")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-sub-heading"
  }, [_c('h4', [_vm._v("Adatok")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-sub-heading"
  }, [_c('h4', [_vm._v("Jogosultságok")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5382139e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/user.vue
// module id = 56
// module chunks = 0